import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionTablesDisplayGridRowDataFragmentGql } from './VirtualConnectionTablesDisplayGridRowDataFragmentGql';

export const FlowUpstreamVirtualConnectionTablesQueryGql: DocumentNode = gql`
query FlowUpstreamVirtualConnectionTablesQuery(
  $flowVizportalUrlId: String!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    upstreamVirtualConnectionTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowDataFragment
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${VirtualConnectionTablesDisplayGridRowDataFragmentGql}
`;
